<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.roomStatus') }}</div>
                <el-select v-model="searchParams.status" placeholder="">
                  <!-- <el-option :value="null" label="Tất cả"></el-option> -->
                  <el-option
                    v-for="item in roomStatusOptions"
                    :key="item.id"
                    :value="item.value"
                    :label="item.label"
                  />
                </el-select>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.roomNo') }}</div>
                <input v-model="searchParams.roomNum" type="text" />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.updatedByPerson') }}</div>
                <el-select
                  v-model="searchParams.updateUser"
                  filterable
                  placeholder=""
                >
                  <el-option
                    v-for="item in accountOptions"
                    :key="item.id"
                    :label="item.full_name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.hotel') }}</div>
                <el-select
                  v-model="searchParams.hotelIdList"
                  multiple
                  collapse-tags
                  filterable
                  clearable
                  placeholder=""
                >
                  <el-option
                    v-for="item in hotelOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.fromDate') }}</div>
                <CalendarSelect
                  v-model="searchParams.dateFrom"
                  mode="date"
                  @input="onChangeDateFrom"
                />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.toDate') }}</div>
                <CalendarSelect
                  v-model="searchParams.dateTo"
                  mode="date"
                  @input="onChangeDateTo"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">
                {{ $t('views.report.roomStatusChangeDiaryReport') }}
              </span>
            </div>
            <div class="flex" style="gap: 10px">
              <InfoBtn @click="noteDialogVisible = true" />
              <el-dropdown trigger="click" @command="onClickDropdownItem">
                <das-button
                  color="primary"
                  size="medium"
                  :rounded="false"
                  outline
                  icon
                >
                  <i class="el-icon-download"></i>
                </das-button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">
                    {{ $t('button.exportPdf') }}
                  </el-dropdown-item>
                  <el-dropdown-item command="excel">
                    {{ $t('button.exportExcel') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <hr />

          <div v-loading="gridLoading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              dom-layout="scroll"
              :auto-size-cell="true"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('dialog.titleNote')"
      :visible.sync="noteDialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>
              Mã phòng: Số phòng có thay đổi trạng thái trong thời gian tìm kiếm
            </li>
            <li>Trạng thái cũ: hiển thị trạng thái cũ trước khi thay đổi</li>
            <li>Trạng thái mới: hiển thị trạng thái mới sau khi thay đổi</li>
            <li>Sự khác nhau: hiển thị sự khác nhau khi chuyển trạng thái</li>
            <li>
              Thời gian cập nhật: hiển thị thời gian cập nhật trạng thái thực tế
              của thao tác cập nhật. Format: DD/MM/YYYY HH:MM:SS
            </li>
            <li>
              Người cập nhật: hiển thị Mã người dùng thực hiện thao tác cập nhật
              trạng thái
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="noteDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DasButton from '@/components/ui/DasButton.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import InfoBtn from './components/InfoBtn.vue'
import { getAllHotel } from '@/api/hotel.js'
import {
  getRoomStatusDiaryReportApi,
  getRoomStatusDiaryReportApiExcel
} from '@/api/report_service/report'
import { getAccount } from '@/api/reception/common'
import moment from 'moment'
import { downFile } from '@/utils/file-handler'
// import { dateTimeFormatter } from '@/utils/dataFormatter'

const getDefaultSearchParams = () => ({
  dateFrom: moment().format('YYYY-MM-DD'),
  dateTo: moment().format('YYYY-MM-DD'),
  status: null,
  hotelIdList: null,
  updateUser: null,
  roomNum: null
})

export default {
  components: {
    DasButton,
    CalendarSelect,
    InfoBtn
  },
  data() {
    return {
      noteDialogVisible: false,
      searchParams: getDefaultSearchParams(),
      datetimeRange: { start: '2023-12-12', end: '2023-12-15' },
      roomStatusOptions: [
        {
          id: 0,
          label: this.$t('variables.all'),
          value: null
        },
        {
          id: 1,
          label: 'Vacant Clean',
          value: '02'
        },
        {
          id: 2,
          label: 'Vacant Dirty',
          value: '01'
        },
        {
          id: 3,
          label: 'Vacant Ready',
          value: '04'
        },
        {
          id: 4,
          label: 'Occupied Clean',
          value: '12'
        },
        {
          id: 5,
          label: 'Occupied Dirty',
          value: '11'
        }
      ],

      // SELECT OPTIONS
      hotelOptions: [],
      accountOptions: [],
      // END OPTIONS

      columns: [
        {
          headerName: this.$t('grid.column.roomCode'),
          field: 'roomNum',
          tooltipField: 'roomNum',
          minWidth: 100,
          maxWidth: 100,
          // cellClass: "grid-cell-centered",
          sortable: false
        },
        {
          headerName: this.$t('grid.column.previousStatus'),
          field: 'statusFrom',
          tooltipField: 'statusFrom',
          minWidth: 150,
          maxWidth: 150,
          // cellClass: "grid-cell-centered",
          // width: 100,
          // flex: 1,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.newStatus'),
          field: 'statusTo',
          tooltipField: 'statusTo',
          minWidth: 150,
          maxWidth: 150,
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.difference'),
          cellRenderer: params => {
            return (
              params.data.differenceFrom + ' -> ' + params.data.differenceTo
            )
          },
          tooltipValueGetter: params => {
            return (
              params.data.differenceFrom + ' -> ' + params.data.differenceTo
            )
          },
          minWidth: 200,
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.updatedTime'),
          field: 'updateTime',
          tooltipField: 'updateTime',
          // cellClass: "grid-cell-centered",
          // width: 100,
          minWidth: 180,
          maxWidth: 180,

          sortable: false
        },
        {
          headerName: this.$t('grid.column.updatedByPerson'),
          field: 'updateUser',
          tooltipField: 'updateUser',
          minWidth: 150,
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false
        }
      ],
      rows: [],
      gridLoading: false
    }
  },
  async mounted() {
    await Promise.all([this.getHotelOptions(), this.getAccountOptions()])
    this.attachData()
  },
  methods: {
    checkValidDateRange(dateFrom, dateTo) {
      if (dateFrom && dateTo && dateFrom > dateTo) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.fromDateMustEarlierThanToDate')
        })
        return false
      }
      return true
    },

    onChangeDateFrom(date) {
      this.searchParams.dateFrom = date
      if (!this.checkValidDateRange(date, this.searchParams.dateTo)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    onChangeDateTo(date) {
      this.searchParams.dateTo = date
      if (!this.checkValidDateRange(this.searchParams.dateFrom, date)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    // SELECT OPTIONS
    async getHotelOptions() {
      await getAllHotel().then(res => {
        this.hotelOptions = res.data
      })
    },

    async getAccountOptions() {
      await getAccount().then(res => {
        this.accountOptions = res.data.map(item => ({
          id: item.account.id,
          username: item.account.username,
          full_name: item.account.full_name
        }))
      })
    },

    getDefaultSearchParams() {
      return getDefaultSearchParams()
    },

    onSearch() {
      this.attachData()
    },
    onReset() {
      this.searchParams = this.getDefaultSearchParams()
      this.attachData()
    },
    onClickDropdownItem(cmmd) {
      // this.$message('click on item ' + cmmd)
      switch (cmmd) {
        case 'pdf':
          break
        case 'excel':
          this.downloadExcel()
          break
        default:
          this.$message('click on item ' + cmmd)
          break
      }
    },
    attachData() {
      this.gridLoading = true
      getRoomStatusDiaryReportApi(this.searchParams)
        .then(res => {
          this.rows = res.data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.gridLoading = false
        })
    },
    downloadExcel() {
      this.gridLoading = true
      getRoomStatusDiaryReportApiExcel(this.searchParams)
        .then(res => {
          const date = this.$moment().format('DD-MM-YYYY')
          downFile(
            res,
            'bao_cao_nhat_ky_thay_doi_trang_thai_phong_' + date + '.xlsx'
          )
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.gridLoading = false
        })
    }
  }
}
</script>

<style></style>
